import { c as _c } from "react/compiler-runtime";
import { FacetValue, FacetValues } from '../interfaces';
import React, { MouseEvent, ReactElement, memo, useState } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import Link from 'next/link';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { PageType } from '@spa/lib/tracking/getPageType';
import classNames from 'clsx';
import styles from './category-navigation.component.module.scss';
import { tracker } from '@spa/lib/tracking/tracker';
import useFullPath from '@spa/lib/react/hooks/useFullPath';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useRuntimeSearchParams from '@spa/lib/react/hooks/useRuntimeSearchParams';
interface Props {
  readonly facet: FacetValues;
  readonly pageType: PageType;
}
function CategoryNavigationComponent(t0) {
  const $ = _c(12);
  const {
    facet,
    pageType
  } = t0;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const {
    formatMessage
  } = useNamespacedIntl("facet");
  const {
    fullPath
  } = useFullPath();
  const searchParams = useRuntimeSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("redirected");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRedirected = t1 === "true";
  let t2;
  if ($[2] !== fullPath) {
    t2 = pathValue => classNames(styles["category-navigation__option"], {
      [styles["category-navigation__option--selected"]]: fullPath === `/c${pathValue}`
    });
    $[2] = fullPath;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const optionClass = t2;
  let t3;
  if ($[4] !== facet.facetCode || $[5] !== facet.values || $[6] !== formatMessage || $[7] !== isCollapsed || $[8] !== isRedirected || $[9] !== optionClass || $[10] !== pageType) {
    const categoryName = formatMessage(`facetNames.${facet.facetCode}`);
    const handleCollapseToggle = () => {
      const nextCollapsed = !isCollapsed;
      setIsCollapsed(nextCollapsed);
      tracker.filterAction({
        filter_category: categoryName,
        filter_element: "link",
        filter_interaction: nextCollapsed ? "close" : "open",
        filter_value: "",
        page_type: pageType
      });
    };
    const handleLinkClick = item => event => {
      tracker.filterAction({
        filter_category: categoryName,
        filter_element: "link",
        filter_interaction: "apply",
        filter_value: item.value,
        page_type: pageType,
        click_url: event.currentTarget.href
      });
    };
    t3 = facet.values.length > 0 ? <div key={facet.facetCode} className={classNames(styles["category-navigation"], {
      [styles["category-navigation--collapsed"]]: isCollapsed
    })} aria-label={formatMessage(`facetNames.${facet.facetCode}`)}><button className={`${styles["category-navigation__header-button"]} text-xl-immutable bold`} aria-expanded={!isCollapsed} aria-controls={`facet-options-${facet.facetCode}`} onClick={handleCollapseToggle}>{formatMessage(`facetNames.${facet.facetCode}`)}<ImageComponent src="/assets/icons/arrow_forward_bold.svg" height={13.5} width={13.5} alt="" className={styles["category-navigation__header-button-arrow"]} aria-hidden="true" /></button><div className={styles["category-navigation__content"]}><ul id={`facet-options-${facet.facetCode}`} className={styles["category-navigation__list"]} aria-label={formatMessage(`facetNames.${facet.facetCode}`)}>{facet.values.map(item_0 => <li key={item_0.code} className={optionClass(item_0.code)}><Link prefetch={false} href={`/c${item_0.code}`} data-track-id={isRedirected ? "redirectSubSelector" : undefined} onClick={handleLinkClick(item_0)}>{item_0.value}{" "}<span className={styles["category-navigation__count"]}>({item_0.count})</span></Link></li>)}</ul></div></div> : <></>;
    $[4] = facet.facetCode;
    $[5] = facet.values;
    $[6] = formatMessage;
    $[7] = isCollapsed;
    $[8] = isRedirected;
    $[9] = optionClass;
    $[10] = pageType;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export default memo(CategoryNavigationComponent);